import React, { useState } from 'react';
import axios from "axios";
import { Link, useNavigate, useParams } from 'react-router-dom'
import { schoolsurl } from '../../../apis/urls';


const MemberAdd = () => {

    const [username,setUsername] = useState('');
    const [role,setRole] = useState('');
    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');
    const [status,setStatus] = useState('');

    const [usernameerror,setUsernameerror] = useState(false);
    const [roleerror,setRoleerror] = useState(false);
    const [passworderror,setPassworderror] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [emailExist, setEmailExist] = useState('')


    //let schools = localStorage.getItem('schoolid')


    const { id } = useParams();
    let navigate = useNavigate();
    const RoutToList = (id) =>{
        let path = 'newPath'; 
        navigate("/members/"+schools)
    }

    let roles = localStorage.getItem('userrole')

    let schools='';

    if( roles === 'SUPERADMIN')
    {
        schools = id;
     
    }else if (roles === 'HO_SCHOOL')
    {
         schools = localStorage.getItem('schoolid')
    }
   // console.log('sccccchid',schools)




    const handleSubmit = async() => {
        let error = 0;
        if(username === '')
        {
            setUsernameerror(true);
            error=1;
        }
        else{
            setUsernameerror(false);
        }
        if(role === "0")
        {
            setRoleerror(true);
            error=1;
        }
        else{
            setRoleerror(false)
        }
        // if(password === '')
        // {
        //     setPassworderror(true);
        //     error=1;
        // }
        // else{
        //     setPassworderror(false)
        // }
        // if(password !== confirmPassword)
        // {
        //     setConfirmPasswordError(true)
        // }else{
        //     setConfirmPasswordError(false)
        // }
        
        if(error === 0)
        {
            let token = "Bearer "+localStorage.getItem('token');
            console.log(token)
            const data = {
                username: username,
                role: role,
                password: password,
                confirmPassword:confirmPassword,
                status :'ACTIVE'
            }
            const instance = axios.create({
                baseURL: schoolsurl+"/"+schools+"/users",
                timeout: 1000000,
                headers: {'authorization': token}
            });
            instance.post('',data).then(async(response) =>{ 
                let path = 'newPath'; 
                
                await navigate("/members/"+schools)
                window.location.reload();
            }).catch((error) =>{
                // console.log('error',error)
                // console.log("email", error)

                setEmailExist(error.response.data.message === 'Validation error')
            });
        }
    }


    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    

                <div className="page-title-wrpr">
                    <div className="page-title-left-column">
                        
                        <h2 className="page-title">New Member</h2>
                    </div>
                    <div className="page-rightside-action-column">
                        
                        
                    </div>
                
                
                </div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to="/school_list">Schools</Link></li>
                        <li className="breadcrumb-item"><Link to="/school_list">Permissions</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">New Member</li>
                    </ol>
                </nav>

                <div className="form-wrpr">
                    <div className="card formcard small">
                        <div className="card-body">
                            <div className="form-group">
                                <label className="degreehead">Email <span style={{color: "red"}}>*</span></label>
                                <input type="text" className="form-control bg-dark dark-theme showtext"
                                onChange={e => {setUsername(e.target.value)}}
                                placeholder="Enter Email" id="name"></input>
                                {
                                    usernameerror
                                    ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Email</div>
                                    :null
                                }
                                {
                                    emailExist
                                    ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>User already Exist</div>
                                    :null
                                }

                            </div>
                            <div className="form-group">
                                <label className="degreehead">Role <span style={{color: "red"}}>*</span></label>
                                <select className="form-control bg-dark dark-theme showtext"
                                onChange={e => {setRole(e.target.value)}}
                                id="status-selector">
                                    <option value="0">Select Role</option>
                                    
                                    <option value="ATHLETIC_MANAGER">Athletic Director</option>
                                    <option value="HO_SCHOOL">Head of School</option>
                                {
                                    roleerror
                                    ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select the Role</div>
                                    :null
                                }
                
                                </select>
                               

                            </div>
                            {/* <div className="form-group">
                                <label className="degreehead">New Password <span style={{color: "red"}}>*</span></label>
                                <input type="password" className="form-control bg-dark dark-theme showtext" 
                                onChange={e => {setPassword(e.target.value)}}
                                placeholder="Enter Password" id="name"></input>
                                {
                                    passworderror
                                    ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Password</div>
                                    :null
                                }
                            </div>
                            <div className="form-group">
                                <label className="degreehead" >Confirm Password <span style={{color: "red"}}>*</span></label>
                                <input type="password" onChange={e => {setConfirmPassword(e.target.value)}} className="form-control bg-dark dark-theme showtext" placeholder="Re enter Password" id="name"></input>
                                {
                                    confirmPasswordError
                                    ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Password not same</div>
                                    :null
                                }
                            </div> */}
                            {/* <div className="form-group">
                                    <label className="degreehead">Status</label>
                                        <select  value={status} onChange={e => {setStatus(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                                <option >Select Status</option>
                                                <option>ACTIVE</option>
                                                <option>INACTIVE</option>
                                                <option>DELETED</option>
                                            
                                        </select>
                                </div> */}

                            <div className="form-group text-right">
                                <button className="btn btn-danger btn-gisa" type="submit" onClick={()=> { RoutToList(id)} }>Cancel</button>
                                <button className="btn btn-primary btn-gisa" type="button" onClick={handleSubmit}>Create</button>
                            </div>


                        </div>
                    </div>
                </div>


                </div>
            </aside>
        </div>
    )
}

export default MemberAdd;